const SANDBOX_BANNER_SECTIONS = new Set(["native-delivery", "journeys"]);

export function isInSandboxBannerSection(pathname: string): boolean {
  // Pathnames are workspace-slug-prefixed, so the section is the second segment.
  const [, , section] = pathname.split("/");
  return section !== undefined && SANDBOX_BANNER_SECTIONS.has(section);
}
